import React from 'react'
import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'
import { Outlet } from 'react-router-dom'

const Root = styled(Box)({
  height: '100vh',
  width: '100%',
  overflow: 'hidden',
  backgroundColor: 'var(--ds-canvas)',
  color: 'var(--ds-ink)',
  fontFamily: 'var(--ds-font)',
})

/** Full-bleed immersive shell for the gallery studio (mirrors AlbumImmersiveLayout) */
export function GalleryStudioLayout() {
  return (
    <Root className='ds-canvas'>
      <Outlet />
    </Root>
  )
}
